import React from 'react';

export const ExternalLinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.66665 2L10.862 4.19533L6.19531 8.862L7.13798 9.80467L11.8046 5.138L14 7.33333V2H8.66665Z"
      fill="#484848"
    />
    <path
      d="M12.6667 12.6667H3.33333V3.33333H8L6.66667 2H3.33333C2.598 2 2 2.598 2 3.33333V12.6667C2 13.402 2.598 14 3.33333 14H12.6667C13.402 14 14 13.402 14 12.6667V9.33333L12.6667 8V12.6667Z"
      fill="#484848"
    />
  </svg>
);

export const ReadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.3667 5.44667L8.36671 1.44667C8.14004 1.3 7.85337 1.3 7.62671 1.44667L1.63337 5.44667C1.44671 5.57334 1.33337 5.78 1.33337 6V13.3333C1.33337 14.0667 1.93337 14.6667 2.66671 14.6667H13.3334C14.0667 14.6667 14.6667 14.0667 14.6667 13.3333V6C14.6667 5.78 14.5534 5.56667 14.3667 5.44667ZM8.00004 2.8L12.8 6L8.00004 9.2L3.20004 6L8.00004 2.8ZM2.66671 13.3333V7.24667L7.63337 10.5533C7.74671 10.6267 7.87337 10.6667 8.00004 10.6667C8.12671 10.6667 8.26004 10.6267 8.36671 10.5533L13.3334 7.24667V13.3333H2.66671Z"
      fill="black"
    />
  </svg>
);

export const UnreadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M13.3334 2.66675H2.66671C1.93337 2.66675 1.33337 3.26675 1.33337 4.00008V12.0001C1.33337 12.7334 1.93337 13.3334 2.66671 13.3334H13.3334C14.0667 13.3334 14.6667 12.7334 14.6667 12.0001V4.00008C14.6667 3.26675 14.0667 2.66675 13.3334 2.66675ZM13.3334 4.00008V4.34008L8.00004 8.48675L2.66671 4.34008V4.00008H13.3334ZM2.66671 12.0001V6.02675L7.59337 9.85341C7.71337 9.94675 7.86004 9.99341 8.00004 9.99341C8.14004 9.99341 8.28671 9.94675 8.40671 9.85341L13.3334 6.02008V11.9934H2.66671V12.0001Z"
      fill="black"
    />
  </svg>
);
